import {Button, Input, Modal} from "antd";
import React, {useState} from "react";
import {useIncreaseCoveragePremiumMutation} from "../../redux/api/coverageConfirmationApiSlice";
import NumberFormat from 'react-number-format';


export const IncreasePremium = ({cUuid, isSurveyDisabled} : {cUuid: string, isSurveyDisabled: boolean}) => {

    const [increasePremium, {isLoading}] = useIncreaseCoveragePremiumMutation()

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
    const [increaseRate, setIncreaseRate] = useState<number | undefined>(undefined)

    return <>
        <Modal
            open={isModalOpen}
            destroyOnClose
            onCancel={()=> setIsModalOpen(false)}
            title={"Modifica premio"}
            okText={"Applica"}
            okButtonProps={{loading: isLoading, disabled: !increaseRate}}
            onOk={()=> {
                if (increaseRate !== undefined)
                 increasePremium({cUuid: cUuid, increase_rates: +increaseRate / 100}).unwrap()
                     .then(()=> {
                         setIsModalOpen(false)
                         setIncreaseRate(undefined)
                     })
            }}
        >
            <div style={{marginBottom: 10}}>Applica la seguente modifica a tutti i tassi presenti</div>
            <NumberFormat
                allowNegative={true}
                suffix={' %'}
                customInput={Input}
                decimalScale={0}
                placeholder={"0 %"}
                onValueChange={(v) => setIncreaseRate(v.floatValue)}
            />
        </Modal>
        <Button
            type={"primary"}
            disabled={isSurveyDisabled}
            onClick={()=> setIsModalOpen(true)}>
            Modifica premio
        </Button>
    </>
}